'use client';

import type { Dispatch } from 'react';
import React, { createContext, useContext, useEffect, useReducer } from 'react';
import type { EntityHistoryActionPayload, EntityHistoryProviderProps, EntityHistoryReducerState } from './entityHistory.types';
import { EntityHistoryActionTypesEnum } from './entityHistory.types';
import { entityHistoryInitialState } from './entityHistory.constants';
import entityHistoryReducer from './reducers/entityHistoryReducer';

// Context
export const EntityHistoryContext = createContext<{
  entityHistory: EntityHistoryReducerState;
  dispatch: Dispatch<EntityHistoryActionPayload>;
}>({
  entityHistory: entityHistoryInitialState,
  dispatch: () => null
});

// Provider
export const EntityHistoryProvider = ({
  children,
  entityHistory
}: EntityHistoryProviderProps) => {
  const [entityHistoryDetails, dispatch] = useReducer(entityHistoryReducer, entityHistory);
  useEffect(() => {
    dispatch({
      type: EntityHistoryActionTypesEnum.replaceAll,
      payload: entityHistory || entityHistoryInitialState
    });
  }, [entityHistory]);
  return <EntityHistoryContext.Provider value={{
    entityHistory: entityHistoryDetails,
    dispatch
  }} data-sentry-element="unknown" data-sentry-component="EntityHistoryProvider" data-sentry-source-file="entityHistoryContext.tsx">
      {children}
    </EntityHistoryContext.Provider>;
};

// Hook to access context
export const useEntityHistoryContext = () => useContext(EntityHistoryContext);